module.exports = __webpack_public_path__ + "img/hand2.0dc45cb7.png";